import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
}

/**
 * Card component - matches Shadcn Card styling
 */
export function Card({ children, className }: CardProps) {
  return (
    <div
      className={`w-full max-w-2xl mx-auto border-0 shadow-none flex-1 flex flex-col bg-transparent text-card-foreground min-h-[600px] ${className || ""}`}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  children: ReactNode;
  className?: string;
}

/**
 * CardHeader - matches Shadcn CardHeader styling
 */
export function CardHeader({ children, className }: CardHeaderProps) {
  return (
    <div className={`flex flex-col p-6 pb-0 ${className || ""}`}>
      {children}
    </div>
  );
}

interface CardContentProps {
  children: ReactNode;
  className?: string;
}

/**
 * CardContent - matches Shadcn CardContent styling
 */
export function CardContent({ children, className }: CardContentProps) {
  return <div className={`p-6 pt-0 ${className || ""}`}>{children}</div>;
}
